import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function SampleEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["product.name"]} children={children} />
    );
}

export function SampleCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"sample"} children={children} />
    );
}